import { render, staticRenderFns } from "./ProviderSettings.vue?vue&type=template&id=fe8df39e"
import script from "./ProviderSettings.vue?vue&type=script&lang=js"
export * from "./ProviderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports